/** Route-level error boundary: friendly message, reload (handles stale chunks after a deploy), report detail. */
import { Button } from '@uatp/ui';
import { isRouteErrorResponse, useRouteError } from 'react-router';

export function RouteError({ inline = false }: { inline?: boolean }) {
  const error = useRouteError();
  const message = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error
      ? error.message
      : String(error);
  // A lazy chunk that no longer exists means a new version was deployed — reloading fixes it.
  const staleChunk = /dynamically imported module|Importing a module script failed|Failed to fetch/i.test(
    message,
  );
  return (
    <div
      className={
        inline ? 'grid min-h-[50vh] place-items-center p-6' : 'grid min-h-dvh place-items-center bg-bg p-6'
      }
    >
      <div className="flex max-w-md flex-col items-center gap-3 text-center">
        <h1 className="text-h2">{staleChunk ? 'A new version is available' : 'Something went wrong'}</h1>
        <p className="m-0 text-13 text-text-2">
          {staleChunk
            ? 'Reload to get the latest version of the console.'
            : 'The page hit an unexpected error. Reloading usually fixes it; your saved work is safe.'}
        </p>
        {!staleChunk && (
          <code className="max-w-full truncate rounded-sm bg-surface-2 px-2 py-1 font-mono text-11 text-text-2">
            {message}
          </code>
        )}
        <div className="flex gap-2">
          <Button onClick={() => window.location.reload()}>Reload</Button>
          <Button variant="secondary" onClick={() => window.location.assign('/')}>
            Go to dashboard
          </Button>
        </div>
      </div>
    </div>
  );
}
